import { triggerAnchorClick } from "../utils";
export function doOpenUrlForDownload(targetUrl) {
  var a = document.createElement('a');
  a.href = targetUrl; // 核心，断掉referrer，用多线程，减少卡顿

  a.rel = 'noreferrer';
  a.download = 'download';
  triggerAnchorClick(a);
}